module.exports = __webpack_public_path__ + "img/222A0318.86a78816.jpg";